import { DeleteQuestionnaireCategoryBulkDocument } from '@/api/queries';
import { DeleteQuestionnaireCategoryBulkInput } from '@/models/gen/graphql';
import graphApi from '@/api';

const [runDeleteCategory] = graphApi(DeleteQuestionnaireCategoryBulkDocument);

export const deleteCategory = async (ids: string[]) => {
  const input: DeleteQuestionnaireCategoryBulkInput = { search: ids.map((id) => ({ id })) };
  return await runDeleteCategory({ input });
};

export default deleteCategory;
